import { render, staticRenderFns } from "./initiation_report.vue?vue&type=template&id=8472a670&scoped=true&"
import script from "./initiation_report.vue?vue&type=script&lang=js&"
export * from "./initiation_report.vue?vue&type=script&lang=js&"
import style0 from "./initiation_report.vue?vue&type=style&index=0&id=8472a670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8472a670",
  null
  
)

export default component.exports